export default __webpack_public_path__ + "img/0aadda13ad7d534f1cecd0a4f7aa80f9.svg";